module.exports = __webpack_public_path__ + "static/media/introducing_typescript.f389cead.png";